import styled from "styled-components";

import { breakpoints, size } from "@/styles/breakpoints";

export const StyledSuccessPage = styled.div`
    position: relative;
    box-sizing: border-box;
    margin: 100px auto;
    max-width: ${size.sm};
    @media ${breakpoints.sm} {
        margin: 20px 16px;
        flex-wrap: wrap;
    }
    align-self: center;
    gap: 20px;
    display: flex;

    ul {
        padding: 0;

        li {
            list-style: none;

            div {
                margin: 0;
            }
        }

        li:not(:last-child) {
            margin-bottom: 10px;
        }
    }
`;

export const StyledPanel = styled.div<{ $color: string }>`
    width: 100%;
    border-radius: var(--radius-10);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    gap: 24px;

    box-sizing: border-box;
    background-color: ${({ $color }) => $color};
`;
